import React, { useState, useEffect } from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Textarea } from '../components/ui/textarea';
import { Badge } from '../components/ui/badge';
import { Switch } from '../components/ui/switch';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle, DialogTrigger } from '../components/ui/dialog';
import { Alert, AlertDescription } from '../components/ui/alert';
import { ScrollArea } from '../components/ui/scroll-area';
import { Separator } from '../components/ui/separator';
import { 
  MessageSquare, 
  Send, 
  RotateCcw, 
  Star, 
  StarOff,
  Copy,
  Check,
  Settings,
  Eye,
  Edit3,
  Zap,
  Save,
  AlertCircle,
  Info,
  ChevronRight,
  Hash,
  BarChart3
} from 'lucide-react';
import api from '../lib/api';

// Ícones para cada canal
const ChannelIcon = ({ channel, className = "w-4 h-4" }) => {
  switch (channel) {
    case 'WHATSAPP':
      return (
        <svg className={className} viewBox="0 0 24 24" fill="currentColor">
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
        </svg>
      );
    case 'INSTAGRAM':
      return (
        <svg className={className} viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
        </svg>
      );
    case 'FACEBOOK':
      return (
        <svg className={className} viewBox="0 0 24 24" fill="currentColor">
          <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
        </svg>
      );
    default:
      return <MessageSquare className={className} />;
  }
};

// Mapeamento de message_key para ícones e cores
const messageKeyConfig = {
  GREETING: { icon: '👋', color: 'bg-green-500' },
  MENU_RESPONSE: { icon: '📋', color: 'bg-blue-500' },
  ORDER_INFO: { icon: '📦', color: 'bg-purple-500' },
  ORDER_SUCCESS: { icon: '✅', color: 'bg-emerald-500' },
  ORDER_STATUS: { icon: '📊', color: 'bg-cyan-500' },
  DELIVERY_TIME: { icon: '⏱️', color: 'bg-orange-500' },
  PAYMENT_PENDING: { icon: '💳', color: 'bg-yellow-500' },
  THANK_YOU: { icon: '❤️', color: 'bg-pink-500' },
  CART_RECOVERY_1: { icon: '🛒', color: 'bg-indigo-500' },
  CART_RECOVERY_2: { icon: '🎁', color: 'bg-violet-500' },
  OUT_OF_HOURS: { icon: '🕒', color: 'bg-gray-500' },
  HUMAN_HANDOFF: { icon: '👨‍💼', color: 'bg-teal-500' },
};

const ChatbotMessagesPage = () => {
  const [messages, setMessages] = useState([]);
  const [variables, setVariables] = useState([]);
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [selectedMessage, setSelectedMessage] = useState(null);
  const [editedContent, setEditedContent] = useState('');
  const [editedTitle, setEditedTitle] = useState('');
  const [editedChannels, setEditedChannels] = useState([]);
  const [showTestDialog, setShowTestDialog] = useState(false);
  const [testResult, setTestResult] = useState(null);
  const [testChannel, setTestChannel] = useState('WHATSAPP');
  const [activeTab, setActiveTab] = useState('messages');
  const [copiedId, setCopiedId] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      setLoading(true);
      const [messagesRes, variablesRes, statsRes] = await Promise.all([
        api.get('/chatbot/default-messages'),
        api.get('/chatbot/variables'),
        api.get('/chatbot/stats')
      ]);
      setMessages(messagesRes.data);
      setVariables(variablesRes.data.variables);
      setStats(statsRes.data);
      setError(null);
    } catch (err) {
      console.error('Erro ao carregar dados:', err);
      setError('Erro ao carregar mensagens. Tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  const selectMessage = (msg) => {
    setSelectedMessage(msg);
    setEditedContent(msg.content);
    setEditedTitle(msg.title);
    setEditedChannels([...msg.channels]);
  };

  const handleSave = async () => {
    if (!selectedMessage) return;
    
    try {
      setSaving(true);
      await api.put(`/chatbot/default-messages/${selectedMessage.id}`, {
        title: editedTitle,
        content: editedContent,
        channels: editedChannels
      });
      
      // Atualizar lista
      setMessages(prev => prev.map(m => 
        m.id === selectedMessage.id 
          ? { ...m, title: editedTitle, content: editedContent, channels: editedChannels }
          : m
      ));
      setSelectedMessage(prev => ({ ...prev, title: editedTitle, content: editedContent, channels: editedChannels }));
      setError(null);
    } catch (err) {
      console.error('Erro ao salvar:', err);
      setError(err.response?.data?.detail || 'Erro ao salvar mensagem');
    } finally {
      setSaving(false);
    }
  };

  const handleToggleActive = async (msg) => {
    try {
      await api.put(`/chatbot/default-messages/${msg.id}`, {
        is_active: !msg.is_active
      });
      
      setMessages(prev => prev.map(m => 
        m.id === msg.id ? { ...m, is_active: !msg.is_active } : m
      ));
      
      if (selectedMessage?.id === msg.id) {
        setSelectedMessage(prev => ({ ...prev, is_active: !msg.is_active }));
      }
    } catch (err) {
      console.error('Erro ao alterar status:', err);
      setError('Erro ao alterar status da mensagem');
    }
  };

  const handleToggleFavorite = async (msg) => {
    try {
      await api.post(`/chatbot/default-messages/${msg.id}/toggle-favorite`);
      
      setMessages(prev => prev.map(m => 
        m.id === msg.id ? { ...m, is_favorite: !msg.is_favorite } : m
      ));
      
      if (selectedMessage?.id === msg.id) {
        setSelectedMessage(prev => ({ ...prev, is_favorite: !msg.is_favorite }));
      }
    } catch (err) {
      console.error('Erro ao alterar favorito:', err);
    }
  };

  const handleReset = async () => {
    if (!selectedMessage) return;
    
    try {
      setSaving(true);
      const res = await api.post(`/chatbot/default-messages/${selectedMessage.id}/reset`);
      
      const updated = res.data;
      setMessages(prev => prev.map(m => m.id === updated.id ? updated : m));
      setSelectedMessage(updated);
      setEditedContent(updated.content);
      setEditedTitle(updated.title);
      setEditedChannels(updated.channels);
      setError(null);
    } catch (err) {
      console.error('Erro ao resetar:', err);
      setError('Erro ao resetar mensagem');
    } finally {
      setSaving(false);
    }
  };

  const handleTest = async () => {
    if (!selectedMessage) return;
    
    try {
      const res = await api.post(`/chatbot/default-messages/${selectedMessage.id}/test`, {
        channel: testChannel
      });
      setTestResult(res.data);
    } catch (err) {
      console.error('Erro ao testar:', err);
      setTestResult({ success: false, error: err.response?.data?.detail || 'Erro ao testar' });
    }
  };

  const handleChannelToggle = (channel) => {
    setEditedChannels(prev => 
      prev.includes(channel)
        ? prev.filter(c => c !== channel)
        : [...prev, channel]
    );
  };

  const insertVariable = (variable) => {
    setEditedContent(prev => prev + variable);
  };

  const copyToClipboard = async (text, id) => {
    await navigator.clipboard.writeText(text);
    setCopiedId(id);
    setTimeout(() => setCopiedId(null), 2000);
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-[400px]">
        <div className="flex flex-col items-center gap-4">
          <div className="w-8 h-8 border-4 border-blue-500 border-t-transparent rounded-full animate-spin" />
          <p className="text-gray-500">Carregando mensagens...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="p-4 md:p-6 space-y-6 bg-gray-50 min-h-screen">
      {/* Header */}
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
        <div>
          <h1 className="text-2xl md:text-3xl font-bold text-gray-900 flex items-center gap-3">
            <MessageSquare className="w-8 h-8 text-blue-600" />
            Mensagens do Chatbot
          </h1>
          <p className="text-gray-500 mt-1">Configure mensagens automáticas para WhatsApp, Instagram e Facebook</p>
        </div>
        
        <div className="flex gap-2">
          <Button variant="outline" onClick={loadData} disabled={loading}>
            <RotateCcw className={`w-4 h-4 mr-2 ${loading ? 'animate-spin' : ''}`} />
            Atualizar
          </Button>
        </div>
      </div>

      {error && (
        <Alert variant="destructive">
          <AlertCircle className="h-4 w-4" />
          <AlertDescription>{error}</AlertDescription>
        </Alert>
      )}

      <Tabs value={activeTab} onValueChange={setActiveTab} className="space-y-4">
        <TabsList className="grid w-full max-w-md grid-cols-2">
          <TabsTrigger value="messages" className="flex items-center gap-2">
            <Edit3 className="w-4 h-4" />
            Mensagens
          </TabsTrigger>
          <TabsTrigger value="stats" className="flex items-center gap-2">
            <BarChart3 className="w-4 h-4" />
            Estatísticas
          </TabsTrigger>
        </TabsList>

        <TabsContent value="messages" className="space-y-4">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
            {/* Lista de mensagens */}
            <Card className="lg:col-span-1">
              <CardHeader className="pb-3">
                <CardTitle className="text-lg">Mensagens Padrão</CardTitle>
                <CardDescription>Selecione uma mensagem para editar</CardDescription>
              </CardHeader>
              <CardContent className="p-0">
                <ScrollArea className="h-[600px]">
                  <div className="space-y-1 p-4">
                    {messages.map((msg) => {
                      const config = messageKeyConfig[msg.message_key] || { icon: '💬', color: 'bg-gray-500' };
                      return (
                        <div
                          key={msg.id}
                          onClick={() => selectMessage(msg)}
                          className={`p-3 rounded-lg cursor-pointer transition-all border ${
                            selectedMessage?.id === msg.id
                              ? 'border-blue-500 bg-blue-50'
                              : 'border-transparent hover:bg-gray-100'
                          }`}
                        >
                          <div className="flex items-center justify-between">
                            <div className="flex items-center gap-3">
                              <span className="text-xl">{config.icon}</span>
                              <div>
                                <p className="font-medium text-sm text-gray-900">{msg.title}</p>
                                <p className="text-xs text-gray-500">{msg.message_key}</p>
                              </div>
                            </div>
                            <div className="flex items-center gap-2">
                              {msg.is_favorite && (
                                <Star className="w-4 h-4 text-yellow-500 fill-yellow-500" />
                              )}
                              <Switch
                                checked={msg.is_active}
                                onCheckedChange={() => handleToggleActive(msg)}
                                onClick={(e) => e.stopPropagation()}
                              />
                            </div>
                          </div>
                          
                          <div className="flex gap-1 mt-2">
                            {msg.channels.map(ch => (
                              <Badge key={ch} variant="secondary" className="text-xs px-1.5 py-0.5">
                                <ChannelIcon channel={ch} className="w-3 h-3" />
                              </Badge>
                            ))}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </ScrollArea>
              </CardContent>
            </Card>

            {/* Editor de mensagem */}
            <Card className="lg:col-span-2">
              {selectedMessage ? (
                <>
                  <CardHeader className="pb-3">
                    <div className="flex items-center justify-between">
                      <div className="flex items-center gap-3">
                        <span className="text-2xl">
                          {messageKeyConfig[selectedMessage.message_key]?.icon || '💬'}
                        </span>
                        <div>
                          <CardTitle className="text-lg">{selectedMessage.title}</CardTitle>
                          <CardDescription className="flex items-center gap-2">
                            <Hash className="w-3 h-3" />
                            {selectedMessage.message_key}
                          </CardDescription>
                        </div>
                      </div>
                      <div className="flex items-center gap-2">
                        <Button
                          variant="ghost"
                          size="icon"
                          onClick={() => handleToggleFavorite(selectedMessage)}
                        >
                          {selectedMessage.is_favorite ? (
                            <Star className="w-5 h-5 text-yellow-500 fill-yellow-500" />
                          ) : (
                            <StarOff className="w-5 h-5 text-gray-400" />
                          )}
                        </Button>
                        <Badge variant={selectedMessage.is_active ? 'default' : 'secondary'}>
                          {selectedMessage.is_active ? 'Ativa' : 'Inativa'}
                        </Badge>
                      </div>
                    </div>
                  </CardHeader>
                  
                  <CardContent className="space-y-6">
                    {/* Título */}
                    <div className="space-y-2">
                      <label className="text-sm font-medium text-gray-700">Título</label>
                      <Input
                        value={editedTitle}
                        onChange={(e) => setEditedTitle(e.target.value)}
                        placeholder="Título da mensagem"
                      />
                    </div>

                    {/* Canais */}
                    <div className="space-y-2">
                      <label className="text-sm font-medium text-gray-700">Canais</label>
                      <div className="flex gap-2">
                        {['WHATSAPP', 'INSTAGRAM', 'FACEBOOK'].map(channel => (
                          <Button
                            key={channel}
                            variant={editedChannels.includes(channel) ? 'default' : 'outline'}
                            size="sm"
                            onClick={() => handleChannelToggle(channel)}
                            className="flex items-center gap-2"
                          >
                            <ChannelIcon channel={channel} className="w-4 h-4" />
                            {channel.charAt(0) + channel.slice(1).toLowerCase()}
                          </Button>
                        ))}
                      </div>
                    </div>

                    {/* Conteúdo */}
                    <div className="space-y-2">
                      <div className="flex items-center justify-between">
                        <label className="text-sm font-medium text-gray-700">Conteúdo da Mensagem</label>
                        <Button
                          variant="ghost"
                          size="sm"
                          onClick={() => copyToClipboard(editedContent, 'content')}
                        >
                          {copiedId === 'content' ? (
                            <Check className="w-4 h-4 text-green-500" />
                          ) : (
                            <Copy className="w-4 h-4" />
                          )}
                        </Button>
                      </div>
                      <Textarea
                        value={editedContent}
                        onChange={(e) => setEditedContent(e.target.value)}
                        placeholder="Digite o conteúdo da mensagem..."
                        className="min-h-[200px] font-mono text-sm"
                      />
                    </div>

                    {/* Variáveis disponíveis */}
                    <div className="space-y-2">
                      <label className="text-sm font-medium text-gray-700 flex items-center gap-2">
                        <Zap className="w-4 h-4" />
                        Variáveis Disponíveis
                      </label>
                      <div className="flex flex-wrap gap-2">
                        {variables.map(v => (
                          <Button
                            key={v.key}
                            variant="outline"
                            size="sm"
                            onClick={() => insertVariable(v.key)}
                            className="text-xs"
                            title={v.description}
                          >
                            {v.key}
                          </Button>
                        ))}
                      </div>
                      <p className="text-xs text-gray-500">
                        Clique em uma variável para inserir no conteúdo
                      </p>
                    </div>

                    <Separator />

                    {/* Ações */}
                    <div className="flex flex-wrap items-center justify-between gap-4">
                      <div className="flex gap-2">
                        <Button
                          variant="outline"
                          onClick={handleReset}
                          disabled={saving}
                        >
                          <RotateCcw className="w-4 h-4 mr-2" />
                          Resetar Padrão
                        </Button>
                        
                        <Dialog open={showTestDialog} onOpenChange={setShowTestDialog}>
                          <DialogTrigger asChild>
                            <Button variant="outline">
                              <Eye className="w-4 h-4 mr-2" />
                              Testar
                            </Button>
                          </DialogTrigger>
                          <DialogContent className="max-w-2xl">
                            <DialogHeader>
                              <DialogTitle>Testar Mensagem</DialogTitle>
                              <DialogDescription>
                                Visualize como a mensagem ficará com dados de exemplo
                              </DialogDescription>
                            </DialogHeader>
                            
                            <div className="space-y-4">
                              <div className="flex gap-2">
                                {['WHATSAPP', 'INSTAGRAM', 'FACEBOOK'].map(ch => (
                                  <Button
                                    key={ch}
                                    variant={testChannel === ch ? 'default' : 'outline'}
                                    size="sm"
                                    onClick={() => setTestChannel(ch)}
                                  >
                                    <ChannelIcon channel={ch} className="w-4 h-4 mr-2" />
                                    {ch}
                                  </Button>
                                ))}
                              </div>
                              
                              <Button onClick={handleTest} className="w-full">
                                <Send className="w-4 h-4 mr-2" />
                                Gerar Preview
                              </Button>
                              
                              {testResult && (
                                <div className="space-y-4">
                                  {testResult.success ? (
                                    <>
                                      <div className="bg-gray-100 rounded-lg p-4">
                                        <p className="text-xs text-gray-500 mb-2">Preview no {testChannel}:</p>
                                        <div className="bg-white rounded-lg p-4 shadow-sm border whitespace-pre-wrap font-sans">
                                          {testResult.rendered_content}
                                        </div>
                                      </div>
                                      
                                      <div className="bg-blue-50 rounded-lg p-4">
                                        <p className="text-xs text-blue-600 font-medium mb-2">Variáveis substituídas:</p>
                                        <div className="grid grid-cols-2 gap-2 text-xs">
                                          {Object.entries(testResult.test_values || {}).map(([key, value]) => (
                                            <div key={key} className="flex items-center gap-2">
                                              <Badge variant="outline" className="font-mono">{key}</Badge>
                                              <ChevronRight className="w-3 h-3" />
                                              <span className="text-gray-600">{value}</span>
                                            </div>
                                          ))}
                                        </div>
                                      </div>
                                    </>
                                  ) : (
                                    <Alert variant="destructive">
                                      <AlertCircle className="h-4 w-4" />
                                      <AlertDescription>{testResult.error}</AlertDescription>
                                    </Alert>
                                  )}
                                </div>
                              )}
                            </div>
                          </DialogContent>
                        </Dialog>
                      </div>
                      
                      <Button onClick={handleSave} disabled={saving}>
                        {saving ? (
                          <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin mr-2" />
                        ) : (
                          <Save className="w-4 h-4 mr-2" />
                        )}
                        Salvar Alterações
                      </Button>
                    </div>

                    {/* Info de uso */}
                    <div className="bg-gray-50 rounded-lg p-4 flex items-center gap-4 text-sm text-gray-600">
                      <Info className="w-5 h-5 text-blue-500" />
                      <div>
                        <span className="font-medium">Uso: </span>
                        {selectedMessage.usage_count} vezes
                        {selectedMessage.last_used_at && (
                          <span className="text-gray-400 ml-2">
                            • Último uso: {new Date(selectedMessage.last_used_at).toLocaleString('pt-BR')}
                          </span>
                        )}
                      </div>
                    </div>
                  </CardContent>
                </>
              ) : (
                <CardContent className="flex flex-col items-center justify-center h-[600px] text-gray-400">
                  <MessageSquare className="w-16 h-16 mb-4" />
                  <p className="text-lg font-medium">Selecione uma mensagem</p>
                  <p className="text-sm">Escolha uma mensagem da lista para editar</p>
                </CardContent>
              )}
            </Card>
          </div>
        </TabsContent>

        <TabsContent value="stats" className="space-y-4">
          {stats && (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
              <Card>
                <CardHeader className="pb-2">
                  <CardDescription>Total de Mensagens</CardDescription>
                  <CardTitle className="text-3xl">{stats.total_messages}</CardTitle>
                </CardHeader>
              </Card>
              
              <Card>
                <CardHeader className="pb-2">
                  <CardDescription>Mensagens Ativas</CardDescription>
                  <CardTitle className="text-3xl text-green-600">{stats.active_messages}</CardTitle>
                </CardHeader>
              </Card>
              
              <Card className="md:col-span-2">
                <CardHeader className="pb-2">
                  <CardDescription>Distribuição por Canal</CardDescription>
                </CardHeader>
                <CardContent>
                  <div className="flex gap-4">
                    {Object.entries(stats.channel_distribution).map(([channel, count]) => (
                      <div key={channel} className="flex items-center gap-2">
                        <ChannelIcon channel={channel} className="w-5 h-5" />
                        <span className="text-sm text-gray-600">{channel}: </span>
                        <Badge variant="secondary">{count}</Badge>
                      </div>
                    ))}
                  </div>
                </CardContent>
              </Card>
              
              <Card className="md:col-span-4">
                <CardHeader>
                  <CardTitle className="text-lg">Uso por Mensagem</CardTitle>
                  <CardDescription>Quantidade de vezes que cada mensagem foi utilizada</CardDescription>
                </CardHeader>
                <CardContent>
                  <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-4">
                    {Object.entries(stats.usage_by_message).map(([key, count]) => {
                      const config = messageKeyConfig[key] || { icon: '💬', color: 'bg-gray-500' };
                      return (
                        <div key={key} className="flex items-center gap-3 p-3 bg-gray-50 rounded-lg">
                          <span className="text-xl">{config.icon}</span>
                          <div>
                            <p className="text-xs text-gray-500">{key}</p>
                            <p className="text-lg font-bold">{count}</p>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </CardContent>
              </Card>
            </div>
          )}
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default ChatbotMessagesPage;
